export const getCountries = (state) => state.countries
export const getTimezones = (state) => state.timezones
